import React, { useCallback, useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import { Grid, getSelectedState, GridColumn } from "@progress/kendo-react-grid";
import "../../styles/components/CommunicationCard.scss";
import { getter } from "@progress/kendo-react-common";
import { GridInnerFilters } from "../GridInnerFilters/GridInnerFilters";
import { isEmptyArray } from "formik";
import { isEmpty, isUndefined } from "lodash-es";
import { useDeepEffect } from "../../abstracts";
import PillComponent from "../PillComponent/PillComponent";
import { faTimesSquare } from "@fortawesome/pro-light-svg-icons";
const DATA_ITEM_KEY = "id";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);
class ProductNameHeader extends React.Component {
  render() {
    return (
      <a className="k-link" onClick={this.props.onClick}>
        <span title={this.props.title}>{this.props.title}</span>
        {this.props.children}
      </a>
    );
  }
}
const CommunicationToSlider = (props) => {
  const {
    getAdmin,
    getSponsor,
    getTextInput,
    getMailIds,
    setGetMailIds,
    setCommunicationToField,
    communicationToField,
    allSponsorData,
    allPlanAdmin,
    panelName,
    values,
    textInput,
    setTextInput,
    setFieldValue,
    isSelectedAllPlanSponsor,
    setIsSelectedAllPlanSponsor,
    isSelectedAllParticipant,
    setIsSelectedAllParticipant,
    isSelectedAllPlanAdmin,
    setIsSelectedAllPlanAdmin,
  } = props;
  // const renderValue = (value) => {
  //   console.log("df")
  //   value = value?.dataItem ? value.dataItem[value.field] : value;
  //   return <td>{value ? <div>{value}</div> : <div> </div>}</td>;
  // };
  const [sponsorOrAdminData, setSponsorData] = useState(allPlanAdmin);
  const [sponsorMail, setSponsorMail] = useState([]);
  const [adminMail, setAdminMail] = useState([]);
  const CustomCell = (props) => {
    const value = props.dataItem[props.field];
    return <td>{value !== null && value !== undefined ? value : "-"}</td>;
  };
  useEffect(() => {
    // setGetMailIds([
    //   ...getMailIds,
    //   ...[].concat(allPlanAdmin, allSponsorData)?.filter((item) => {
    //     if (
    //       getAdmin
    //         ?.split(",")
    //         .map((item) => Number(item))
    //         .includes(item.id) &&
    //       item.sponsorOrAdmin == "admin"
    //     )
    //       return item;
    //     else if (
    //       getSponsor
    //         ?.split(",")
    //         .map((item) => Number(item))
    //         .includes(item.id) &&
    //       item.sponsorOrAdmin == "Sponsor" &&
    //       levelOfCommunication == 2
    //     )
    //       return item;
    //   }),
    // ]);
    setAdminMail([
      ...getMailIds?.filter((x) => x.sponsororAdmin == "admin"),
      ...allPlanAdmin?.filter((item) => {
        if (
          getAdmin
            ?.split(",")
            .map((item) => Number(item))
            .includes(item.id)
        )
          return item;
      }),
    ]);
    setSponsorMail([
      ...getMailIds?.filter((x) => x.sponsororAdmin == "Sponsor"),
      ...allSponsorData?.filter((item) => {
        if (
          getSponsor
            ?.split(",")
            .map((item) => Number(item))
            .includes(item.id)
        )
          return item;
      }),
    ]);
    let adminids = getMailIds
      ?.filter((x) => x.sponsororAdmin == "admin")
      ?.map((x) => x.id);
    let planAdmins = [
      ...allPlanAdmin?.map((item) => {
        if (
          getAdmin
            ?.split(",")
            .map((item) => Number(item))
            .includes(item.id) ||
          adminids.includes(item.id) ||
          isSelectedAllPlanAdmin
        )
          return { ...item, selected: true };
        else return item;
      }),
    ];
    const dataSources = {
      Sponsor: allSponsorData,
      Admin: allPlanAdmin,
      All: [...allPlanAdmin, ...allSponsorData],
    };
    setSponsorData(
      [].concat(dataSources[values.buttonName])?.map((item) => {
        if (
          !isEmpty(
            getMailIds?.filter(
              (data) =>
                data?.id == item?.id &&
                data?.sponsororAdmin == item?.sponsororAdmin
            )
          ) ||
          (isSelectedAllPlanAdmin && item?.sponsororAdmin == "admin") ||
          (isSelectedAllPlanSponsor && item?.sponsororAdmin == "Sponsor")
        )
          return { ...item, selected: true };
        else return item;
      })
    );
    setTextInput({
      chips: [],
      inputText: getTextInput,
    });
  }, [isSelectedAllPlanAdmin,
    isSelectedAllPlanSponsor,
  isSelectedAllParticipant]);
  useDeepEffect(() => {
    if (isSelectedAllPlanAdmin && isSelectedAllPlanSponsor) {
      setGetMailIds([]);
      setAdminMail([]);
      setSponsorMail([]);
    } else if (isSelectedAllPlanAdmin) {
      setGetMailIds([...sponsorMail]);
      setAdminMail([]);
    } else if (isSelectedAllPlanSponsor) {
      setGetMailIds([...adminMail]);
      setSponsorMail([]);
    }
  }, [
    isSelectedAllPlanAdmin,
    isSelectedAllPlanSponsor,
    adminMail,
    sponsorMail,
  ]);
  const onSelectionChange = (data) => {
    const updatedSponsorData = sponsorOrAdminData?.map((item) =>
      item.sponsororAdmin === data.dataItem.sponsororAdmin && item.id === data.dataItem.id
        ? { ...item, selected: !item.selected }
        : item
    );
    
    setSponsorData(updatedSponsorData);
  
    const adminSelected = updatedSponsorData?.filter(item => item.sponsororAdmin === "admin" && item.selected);
    const sponsorSelected = updatedSponsorData?.filter(item => item.sponsororAdmin === "Sponsor" && item.selected);
    const adminNotSelected = updatedSponsorData?.filter(item => item.sponsororAdmin === "admin" && !item.selected);
    const sponsorNotSelected = updatedSponsorData?.filter(item => item.sponsororAdmin === "Sponsor" && !item.selected);
  
    if (values["buttonName"] === "All") {
      setIsSelectedAllPlanAdmin(false);
      setIsSelectedAllPlanSponsor(false);
      setIsSelectedAllParticipant(false);
  
      setGetMailIds([...adminSelected, ...sponsorSelected]);
      setAdminMail(adminSelected);
      setSponsorMail(sponsorSelected);
  
      if (adminNotSelected.length === 0) setIsSelectedAllPlanAdmin(true);
      if (sponsorNotSelected.length === 0) setIsSelectedAllPlanSponsor(true);
    } 
    else if (values["buttonName"] === "Admin") {
      setIsSelectedAllPlanAdmin(false);
  
      setGetMailIds([...adminSelected, ...sponsorMail]);
      setAdminMail(adminSelected);
  
      if (adminNotSelected.length === 0) setIsSelectedAllPlanAdmin(true);
    } 
    else if (values["buttonName"] === "Sponsor") {
      setIsSelectedAllPlanSponsor(false);
  
      setGetMailIds([...adminMail, ...sponsorSelected]);
      setSponsorMail(sponsorSelected);
  
      if (sponsorNotSelected.length === 0) setIsSelectedAllPlanSponsor(true);
    } 
    else {
      if (sponsorNotSelected.length > 0) {
        setIsSelectedAllPlanSponsor(false);
        setGetMailIds([...adminMail, ...sponsorSelected]);
        setSponsorMail(sponsorSelected);
      }
  
      if (adminNotSelected.length > 0) {
        setIsSelectedAllPlanAdmin(false);
        setGetMailIds([...adminSelected, ...sponsorMail]);
        setAdminMail(adminSelected);
      }
    }
  };
  const onHeaderSelectionChange = (event) => {
    let select = event?.syntheticEvent?.target?.checked;
    if (values["buttonName"] == "Admin") {
      setIsSelectedAllPlanAdmin(select);
      setSponsorData(() => {
        return sponsorOrAdminData?.map((item) => {
          if (item?.sponsororAdmin == "admin") {
            return { ...item, selected: select };
          }
        });
      });
    } else if (values["buttonName"] == "Sponsor") {
      setIsSelectedAllPlanSponsor(select);
      setSponsorData(() => {
        return sponsorOrAdminData?.map((item) => {
          if (item?.sponsororAdmin == "Sponsor") {
            return { ...item, selected: select };
          }
        });
      });
    } else {
      setSponsorData(() => {
        return sponsorOrAdminData?.map((item) => {
          return { ...item, selected: select };
        });
      });
      setIsSelectedAllPlanAdmin(select);
      setIsSelectedAllPlanSponsor(select);
    }
  };
  const [inputBox, setInputBox] = useState(false);
  const removeAllSponsor = () => {
    setIsSelectedAllPlanSponsor(false);
  };
  const removeAllAdmin = () => {
    setIsSelectedAllPlanAdmin(false);
  };
  const removeCell = (email) => {
    let admin = adminMail?.filter((x) =>
      email.sponsororAdmin == "admin" ? x.id !== email.id : x
    );
    let sponsor = sponsorMail?.filter((x) =>
      email.sponsororAdmin == "Sponsor" ? x.id !== email.id : x
    );
    let adminIds = adminMail
      ?.filter((x) => email.sponsororAdmin == "admin" && x.id == email.id)
      ?.map((x) => x.id);
    let sponsorIds = sponsorMail
      ?.filter((x) => email.sponsororAdmin == "Sponsor" && x.id == email.id)
      ?.map((x) => x.id);

    setAdminMail(admin);
    setSponsorMail(sponsor);
    setGetMailIds([...admin, ...sponsor]);
    setSponsorData(
      sponsorOrAdminData?.map((item) => {
        if (adminIds.includes(item.id) && item.sponsororAdmin == "admin") {
          return { ...item, selected: false };
        } else if (
          sponsorIds.includes(item.id) &&
          item.sponsororAdmin == "Sponsor"
        ) {
          return { ...item, selected: false };
        } else {
          return item;
        }
      })
    );
  };

  const removeCell1 = (email) => {
    var newtextInput = textInput.chips.filter((elt) => email != elt);
    textInput.chips = newtextInput;
    setTextInput({
      chips: [...textInput.chips],
      inputText: "",
    });
  };

  function AppRepeat() {
    setInputBox(false);
  }
  const handleChange = (event) => {
    setTextInput({
      chips: [...textInput.chips],
      inputText: event.target.value,
    });
  };

  const handleKeyDown = (event) => {
    // if (event.key === "Enter") {
    //   setInputBox(true);
    //   setTextInput({
    //     chips: [...textInput.chips, textInput.inputText],
    //     inputText: "",
    //   });
    // }
  };

  const handleClick = (input, data) => {
    if (input === 0) {
      setFieldValue("buttonName", "All");
      setSponsorData(
        [].concat(allPlanAdmin, allSponsorData)?.map((item) => {
          if (
            !isEmpty(
              getMailIds?.filter(
                (data) =>
                  data?.id == item?.id &&
                  data?.sponsororAdmin == item?.sponsororAdmin
              )
            ) ||
            (isSelectedAllPlanAdmin && item?.sponsororAdmin == "admin") ||
            (isSelectedAllPlanSponsor && item?.sponsororAdmin == "Sponsor")
          )
            return { ...item, selected: true };
          else return item;
        })
      );
    } else if (input === 1) {
      setFieldValue("buttonName", "Sponsor");
      setSponsorData(
        allSponsorData?.map((item) => {
          if (
            !isEmpty(
              getMailIds?.filter(
                (data) =>
                  data?.id == item?.id &&
                  data?.sponsororAdmin == item?.sponsororAdmin
              )
            ) ||
            isSelectedAllPlanSponsor
          )
            return { ...item, selected: true };
          else return item;
        })
      );
    } else if (input === 2) {
      setFieldValue("buttonName", "Admin");
      setSponsorData(
        allPlanAdmin?.map((item) => {
          if (
            !isEmpty(
              getMailIds?.filter(
                (data) =>
                  data?.id == item?.id &&
                  data?.sponsororAdmin == item?.sponsororAdmin
              )
            ) ||
            isSelectedAllPlanAdmin
          )
            return { ...item, selected: true };
          else return item;
        })
      );
    }
  };

  const options = [
    {
      label: "All",
      index: 0,
      name: "All",
    },
    {
      label: "Sponsor",
      index: 1,
      name: "Sponsor",
    },
    {
      label: "Plan Admin",
      index: 2,
      name: "Admin",
    },
  ];
  return (
    <>
      <div className="communicationTo-header">{panelName}</div>
      <hr className="CommunicationTo-horizontal mb-4"></hr>
      {(values?.level && values?.level != 1 ) && (
        <div>
          <div className="pillInputButton d-flex mb-10p">
            {options?.map((_) => {
              return (
                <PillComponent
                  label={_?.label}
                  handleClick={handleClick}
                  inputForClick={_?.index}
                  className={
                    values["buttonName"] == _?.name
                      ? "filteredActiveButton mr-10p"
                      : "mr-10p"
                  }
                  isInput={false}
                />
              );
            })}
          </div>

          <div>
            <Grid
              data={sponsorOrAdminData}
              style={{
                height: "325px",
                padding: "0px",
              }}
              selectedField={SELECTED_FIELD}
              selectable={{
                enabled: true,
                drag: false,
                cell: false,
                mode: "multiple",
              }}
              resizable={false}
              onHeaderSelectionChange={onHeaderSelectionChange}
              onSelectionChange={onSelectionChange}
            >
              <GridColumn field={SELECTED_FIELD} width="50px" />
              <GridColumn
                width={164}
                field="name"
                title="Name"
                headerCell={ProductNameHeader}
                // cell={renderValue}
              />
              <GridColumn
                width={164}
                field="ssn"
                title="SSN"
                headerCell={ProductNameHeader}
                cell={CustomCell}
              />
              {/* <GridColumn
            width={164}
            field="companyName"
            title="Company Name"
            headerCell={ProductNameHeader}
            // cell={renderValue}
          /> */}
              <GridColumn
                width={164}
                field="sponsororAdmin"
                title="User Type"
                headerCell={ProductNameHeader}
                // cell={renderValue}
              />
              <GridColumn
                width={164}
                field="planName"
                title="Plan Name"
                headerCell={ProductNameHeader}
                // cell={renderValue}
              />
              <GridColumn
                width={164}
                field="email"
                title="Email ID"
                headerCell={ProductNameHeader}
                // cell={renderValue}
              />
            </Grid>
          </div>
        </div>
      )}

      <div>
        <div
          className="CommunicationTo-horizontal mb-3 mt-3"
          style={{
            fontWeight: "bold",
          }}
        >
          Recipient List (To)
        </div>
        <div
          className="communicationTo-scrollable ct-scroll-flair d-flex"
          onClick={AppRepeat}
        >
          <div className="d-flex mt-2 w-100">
            <div
              className="d-flex justify-content-space-between p-2 m-2"
              contentEditable="false"
              style={{
                border: "1px solid #bdbdbd",
                borderRadius: "5px",
                cursor: "pointer",
                //maxWidth: "200px",
                minWidth: "140px",
                height: "38px",
              }}
            >
              <Form.Check
                custom
                id={"showTerminated"}
                name="showTerminated"
                type="switch"
                autoFocus="off"
                onChange={() => {
                  setIsSelectedAllParticipant(!isSelectedAllParticipant);
                }}
                checked={isSelectedAllParticipant}
                className="medium"
              />
              <span className="ml-4">Tag Participants</span>
            </div>
            {
              <div
                className="d-flex justify-content-space-between p-2 m-2"
                contentEditable="false"
                style={{
                  border: "1px solid #bdbdbd",
                  borderRadius: "5px",
                  cursor: "pointer",
                  //maxWidth: "200px",
                  minWidth: "140px",
                  height: "38px",
                }}
              >
                <Form.Check
                  custom
                  id={"isGlobalParticipant"}
                  name="isGlobalParticipant"
                  type="switch"
                  autoFocus="off"
                  onChange={() => {
                    setIsSelectedAllPlanSponsor(!isSelectedAllPlanSponsor);
                  }}
                  checked={isSelectedAllPlanSponsor}
                  className="medium"
                />
                <span className="ml-4">Tag Sponsors</span>{" "}
              </div>
            }
            <div
              className="d-flex justify-content-space-between p-2 m-2"
              contentEditable="false"
              style={{
                border: "1px solid #bdbdbd",
                borderRadius: "5px",
                cursor: "pointer",
                //maxWidth: "200px",
                minWidth: "140px",
                height: "38px",
              }}
            >
              <Form.Check
                custom
                id="isGlobalAdmin"
                name="isGlobalAdmin"
                type="switch"
                autoFocus="off"
                onChange={() => {
                  setIsSelectedAllPlanAdmin(!isSelectedAllPlanAdmin);
                }}
                checked={isSelectedAllPlanAdmin}
                className="medium"
              />
              <span className="ml-4">Tag Admins</span>
            </div>
          </div>
          <div className="justify-content-space-around align-items-center d-flex">
            {getMailIds?.map((x, i) => {
              return (
                <div
                  className={`d-flex justify-content-space-between ${
                    i === 0 ? "ml-10p" : ""
                  } mr-10p`}
                  contentEditable="false"
                >
                  <PillComponent
                    label={x?.email ? x?.email : x?.planName}
                    iconRight={true}
                    icon={faTimesSquare}
                    isInput={true}
                    isIconClick={true}
                    iconClick={removeCell}
                    inputForClick={x}
                  />
                </div>
              );
            })}
            {isSelectedAllParticipant && (
              <div
                className="d-flex justify-content-space-between m-2"
                contentEditable="false"
              >
                <PillComponent
                  label="All Participant"
                  iconRight={true}
                  icon={faTimesSquare}
                  isInput={true}
                  isIconClick={true}
                  iconClick={setIsSelectedAllParticipant}
                  inputForClick={false}
                />
              </div>
            )}

            {isSelectedAllPlanSponsor && (
              <div
                className="d-flex justify-content-space-between m-2"
                contentEditable="false"
              >
                <PillComponent
                  label="All Sponsor"
                  iconRight={true}
                  icon={faTimesSquare}
                  isInput={true}
                  isIconClick={true}
                  iconClick={removeAllSponsor}
                  inputForClick={""}
                />
              </div>
            )}

            {isSelectedAllPlanAdmin && (
              <div
                className="d-flex justify-content-space-between m-2"
                contentEditable="false"
              >
                <PillComponent
                  label="All Admin"
                  iconRight={true}
                  icon={faTimesSquare}
                  isInput={true}
                  isIconClick={true}
                  iconClick={removeAllAdmin}
                  inputForClick={""}
                />
              </div>
            )}
            <div className="d-flex justify-content-space-between">
              {textInput?.chips?.map((chip, index) => {
                return (
                  <div
                    className="d-flex justify-content-space-between p-2 m-2"
                    contentEditable="false"
                    style={{
                      border: "1px solid #bdbdbd",
                      borderRadius: "5px",
                      cursor: "pointer",
                      //maxWidth: "200px",
                      minWidth: "140px",
                      height: "38px",
                    }}
                    key={index}
                  >
                    <div
                      style={{
                        margin: "auto",
                      }}
                    >
                      {chip}
                    </div>
                    <i
                      className="fal fa-times-square mt-1 ml-2"
                      onClick={() => removeCell1(chip)}
                    ></i>
                  </div>
                );
              })}
              {!inputBox ? (
                <input
                  style={{
                    border: "1px solid #bdbdbd",
                    borderRadius: "5px",
                    cursor: "pointer",
                    //maxWidth: "200px",
                    minWidth: "140px",
                    height: "38px",
                  }}
                  className="d-flex justify-content-space-between p-2 m-2"
                  type="text"
                  id="message"
                  name="message"
                  onKeyDown={handleKeyDown}
                  onChange={handleChange}
                  defaultValue={getTextInput}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CommunicationToSlider;
